import React from 'react';

const markup = String.raw`<div class="page-head">
<div><h1 class="page-title">Vendor dashboard</h1><p class="page-desc" id="vendPageDesc">AHB Pharma · Self-service portal</p></div>
<div class="inline-style-50">
<select class="vendor-select" id="vendVendorSelect" onchange="vendSwitchVendor(this.value)"></select>
<div class="page-date">18 Aug 2026<br/>2:58 PM</div>
</div>
</div>`;

export default function VendorHeader() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
